import { useState } from "react";
import { PropTypes } from 'prop-types';





const Articles = ({ articles }) => {
    const [selectedArticle, setSelectedArticle] = useState(0);
    const handleArticleClick = (index) => {
        setSelectedArticle(index);
        console.log(index)
    };
    const [showFullContent, setShowFullContent] = useState(false);

    const handleShowMore = () => {
        setShowFullContent(true);
    };

    const handleShowLess = () => {
        setShowFullContent(false);
    };


    return (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">

            {(selectedArticle !== null && articles != null) && (
                <div className="flex flex-col gap-5 w-full">
                    <div className="w-full h-[30rem] lg:h-[60%] bg-center bg-cover bg-no-repeat " style={{ backgroundImage: `url('${articles[selectedArticle]?.img}')` }}>

                    </div>
                    <div>
                        <span className="text-neutral-800 text-xs font-normal  leading-3">
                            {articles[selectedArticle].author}
                        </span>
                        <h2 className=" text-neutral-800 text-lg font-medium ">
                            {articles[selectedArticle].title}
                        </h2>
                        <div className="text-neutral-800 flex flex-col gap-5 text-opacity-60 text-sm font-normal  leading-none">
                            <span className="leading-5 ">
                                {showFullContent ? (
                                    <>
                                        {articles[selectedArticle].content}
                                        <a href={articles[selectedArticle].seeMore} target="_blank" rel="noopener noreferrer" className="text-cyan-600 text-sm font-bold  leading-none ml-2">Learn More</a>
                                        <button
                                            className="text-cyan-600 text-sm font-bold  leading-none ml-2"
                                            onClick={handleShowLess}
                                        >
                                            Show Less
                                        </button></>
                                ) : (
                                    <>

                                        <p
                                            className="line-clamp-2"
                                        >
                                            {
                                                articles[selectedArticle]?.content
                                            }
                                        </p>
                                        <button
                                            className="text-cyan-600 text-sm font-bold  leading-none ml-2"
                                            onClick={handleShowMore}
                                        >
                                            Show More
                                        </button>

                                    </>
                                )}

                            </span>
                        </div>
                    </div>
                </div>
            )}

            <div className="flex flex-col gap-8 w-full">
                {articles?.filter((i, index) => index !== selectedArticle).map((article, index) => (
                    <div
                        key={index}
                        className="flex flex-col items-center justify-center md:flex-row md:items-start gap-5  md:justify-start cursor-pointer"
                        onClick={() => handleArticleClick(articles.indexOf(article))}
                    >
                        <div className="w-48 h-48 md:w-28 md:h-24 bg-center bg-cover bg-no-repeat " style={{ backgroundImage: `url('${article.img}')` }}>

                        </div>
                        <div className="flex flex-col gap-2 pt-2 items-center justify-center md:items-start md:justify-start">
                            <span className="text-neutral-700 text-xs font-normal text-center md:text-left leading-3">
                                {article.author}
                            </span>
                            <h2 className="text-neutral-700 text-base font-medium text-center md:text-left ">
                                {article.title}
                            </h2>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}
Articles.propTypes = {
    articles: PropTypes.array
}
export default Articles